import { App, Nav } from 'ionic-angular';
import { ClientServiceProvider } from '../../../clients/services/client-service/client-service';
import { ConfigServiceProvider } from '../../../core/services/config-service/config-service';
import { DataSource } from '../../interfaces/data-source.interface';
import { DataSourceConfig } from '../../interfaces/data-source-config.interface';
import { ENVIRONMENT } from '../../../../../environments/environment';
import { FilterOutput } from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/filter-outpt.interface';
import { FiltersConfig } from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/filters-config.interface';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IClientModel } from '../../../clients/interfaces/i-client-model.interface';
import { Injectable } from '@angular/core';
import { IRecipient } from '../../../clients/interfaces/i-recipient.interface';
import { filter, map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { PlayerServiceProvider } from '../../../core/services/player-service/player-service';
import { SellionsCalendarEvent } from '../../interfaces/sellions-calendar-event.interface';
import {  SellionsEngineCalendarEvent, SellionsEvent } from '../events-service/events-service';
import { Utils } from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/utils/utils.class';
import {
  FilterSet
} from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/filter-set.interface';
import { CalendarPage } from '../../pages/calendar/calendar';
import { ScreenActionCallback } from '../../../../shared/components/sellions-dynamic-event/screen-action-callback';

@Injectable()
export class EngineCalendarEventsDataSource implements DataSource {

  public eventLayout: string;
  private lastSynchronizationTime: Date;
  private readonly synchronizeTimeDiff = ENVIRONMENT.eventsSynchronizeTimeDifferenceMiliseconds;
  private config: DataSourceConfig & {httpParams?: { [key: string]: string }} = {} as DataSourceConfig ;
  private dataContext: any;
  private _filters: FilterOutput[] = [];

  constructor(
    private app: App,
    private configService: ConfigServiceProvider,
    private clientsService: ClientServiceProvider,
    private player: PlayerServiceProvider,
    private http: HttpClient,
  ) {}

  public get filters(): FilterOutput[] {
    return this._filters;
  }

  public getEvents(): Promise<SellionsCalendarEvent[]> {
    const user = this.player.player$.value;
    this.synchronize();

    if (user) {
      let rawEvents = this.getRawEvents({});
      let mappedRawEvents = rawEvents
        .pipe(
          take(1),
          map((events) => this.mapToSellionsCalendarEvents(events)),
        )
        .toPromise();
      return mappedRawEvents;
    }
    else return Promise.reject('no user avaible in engine-calendar-events-data-source');
  }

  public filter(filters: FilterOutput[] | FilterSet): Promise<SellionsCalendarEvent[]> {
    this._filters = Array.isArray(filters) ? filters : filters.filters;
    let filtersWithDictionaryValues = this.mapFiltersToDictionary(this._filters);
    let searchQuery = (!Array.isArray(filters) && filters.searchQuery && filters.searchQuery.length > 0)
      ? {searchQuery : filters.searchQuery} : {};
    const payload = this.prepareFilterPayload({...searchQuery, ...filtersWithDictionaryValues});
    let rawEvents = this.getRawEvents(payload);
    let mappedRawEvents = rawEvents
      .pipe(
        take(1),
        map((events) => this.mapToSellionsCalendarEvents(events)),
      )
      .toPromise();
    return mappedRawEvents;
  }

  public search(query: string): Promise<SellionsCalendarEvent[]> {
    return this.filter([{ type: 'input', value: query, column: 'searchQuery', queryValue: null }]);
  }

  private mapFiltersToDictionary(filters: FilterOutput[]): { [key: string]: string } {
    const dictionary = {};
    filters.forEach((filter) => (dictionary[filter.column] = filter.value));
    return dictionary;
  }

  private getRawEvents(params: any): Observable<{content:SellionsEngineCalendarEvent[]}> {
    let url = this.configService.getEngineUrl('calendarEventsGet');
    let finalParams = params;
    if(this.config.httpParams) {
      let mappedParams = {};
      Object.keys(this.config.httpParams).forEach((key) => mappedParams[key] = Utils.evaluateString(this.config.httpParams[key], this.dataContext));
      finalParams = {...params, ...mappedParams};
    }
    return this.http.get<{content:SellionsEngineCalendarEvent[]}>(url, { params: finalParams });
  }

  private mapToSellionsCalendarEvents(events: {content:SellionsEngineCalendarEvent[]}): SellionsCalendarEvent[] {
    return events.content.map((event) => {
      return {
        displayComponent: 'SellionsDynamicEventComponent',
        displayComponentData: {
          event,
          infoTextTemplate: this.config.params['infoTextTemplate'],
          subInfoTextTemplate: this.config.params['subInfoTextTemplate'],
          subDateTextTemplate: this.config.params['subDateTextTemplate'],
          additionalTextTemplate: this.config.params['additionalTextTemplate']
        },
        dateFrom: event.startDate,
        dateTo: event.endDate,
        dataSource: this,
      };
    });
  }

  public setConfig(config: DataSourceConfig) {
    this.config = config;
  }

  public setDataContext(context: any) {
    this.dataContext = context;
  }

  public async detailsOnClick(event: SellionsCalendarEvent) {
    let detailsConfig = {
      ...this.config.detailsOnClick.componentData,
      event,
      calendar: true
    }
    if(this.config.detailsOnClick['objectKey'])
      detailsConfig[this.config.detailsOnClick['objectKey']] = event.displayComponentData;

    let nav: any = this.app.getRootNav();
    let activeChildNavs: any[] = nav.getActiveChildNavs();
    if (activeChildNavs.length === 1 && activeChildNavs[0] instanceof Nav) {
      nav = activeChildNavs[0];
    }

    // @ts-ignore
    return nav.push(this.config.detailsOnClick.component, detailsConfig);
  }

  private prepareFilterPayload(filters: { [key: string]: string | number }): HttpParams {
    let payload: HttpParams = {} as HttpParams,
       userId: number;
    if(filters['searchQuery']) {
      payload['searchQuery'] = filters['searchQuery'];
    }
    payload['filters'] = JSON.stringify(Object.keys(filters).filter(key => key !== 'searchQuery').reduce(function(result, key) {
      let finalKey = key;
      if(key.indexOf('.') >= 0) {
        let split = key.split('.');
        finalKey = split[0];
        for(let i=1; i < split.length; i++) {
          if(i === split.length-1) {
            finalKey = finalKey + '->>\'' + split[i] + '\'';
          } else {
            finalKey = finalKey + '->\'' + split[i] + '\'';
          }
        }
      }
      result[finalKey] = ['=' + filters[key]];
      return result
    }, {}));

    return payload;
  }

  public synchronize() {
    let currentTime = Number(new Date());
    let lastUpdate = this.lastSynchronizationTime ? Number(this.lastSynchronizationTime) : 0;

    if (currentTime - lastUpdate > this.synchronizeTimeDiff) {
      this.http
        .post(this.configService.getUrl('synchronize'), {})
        .pipe(take(1))
        .subscribe(() => (this.lastSynchronizationTime = new Date()));
    }
  }

  public getFiltersConfig(): FiltersConfig {
    return this.config.filters;
  }

  getRawEvent(event: SellionsCalendarEvent): any {
    return event.displayComponentData.event;
  }

  setOnScreenActionCallback(ref: ScreenActionCallback): void {
    throw new Error("Method not implemented.");
  }
}



// WEBPACK FOOTER //
// ./src/modules/calendar/services/engine-calendar-events-data-source/engine-calendar-events-data-source.ts